<template>
  <div class="login-body">
    <div class="container relative h-full py-2 mx-auto sm:px-10">
      <div class="form-flex h-full">
        <div class="hidden min-h-full pl-4 xl:flex xl:flex-col" style="flex: 1">
          <div class="m-auto relative">
            <h1 class="text-white text-6xl mt-44">学生阅读成长系统</h1>
            <img src="../../assets/login/login-box-bg.png" class="w-full ml-48 -enter-x" style="width: 80%" />
            <div class="w-full desc absolute top-80 left-1">
              <p class="form-flex mb-8" style="align-items: center">
                <img src="../../assets/login/icon-check.png" class="w-30px" />
                <span class="text-white text-2xl pl-4" style="opacity: 0.5">促进学生阅读素养水平</span>
              </p>
              <p class="form-flex mb-8" style="align-items: center">
                <img src="../../assets/login/icon-check.png" class="w-30px" />
                <span class="text-white text-2xl pl-4" style="opacity: 0.5">让孩子在阅读中成长、在评价中进步</span>
              </p>
              <p class="form-flex" style="align-items: center">
                <img src="../../assets/login/icon-check.png" class="w-30px" />
                <span class="text-white text-2xl pl-4" style="opacity: 0.5">为阅读提供科学、系统的解决方案</span>
              </p>
            </div>
            <div class="dot form-flex absolute left-2" style="top: 520px">
              <div class="dot-item mr-4" style="opacity: 0.5"></div>
              <div class="dot-item mr-4"></div>
              <div class="dot-item"></div>
            </div>
          </div>
        </div>
        <div class="form-flex h-full" style="align-items: start">
          <div class="relative w-full px-5 mx-auto form-mt rounded-md shadow-md sm:px-8 xl:p-4 xl:shadow-none sm:w-3/4 lg:w-2/4 xl:w-auto enter-x">
            <LoginForm />
            <!-- <ForgetPasswordForm />
            <RegisterForm />
            <MobileForm />
            <QrCodeForm /> -->
          </div>
        </div>
      </div>
    </div>
    <div class="bottom w-full fixed bottom-15 mx-auto">
      <div class="form-flex text-white" style="align-items: center; justify-content: center; font-size: 14px">
        <img src="../../assets/login/bottom-logo.png" class="h-30px" />
        <div style="opacity: 0.5">
          <span>京师数据（北京）教育科技有限公司</span>
          <span class="px-4">|</span>
          <span>地址：北京市海淀区学院南路12号北京师范大学南院57号楼（100082)</span>
          <span class="px-4">|</span>
          <span>邮编：100082</span>
          <span class="px-4">|</span>
          <span>电话：010-62200826</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as homeApi from '@/api/home'
import { ERR_OK } from '@/api/index'
import LoginForm from './LoginForm.vue'
import '../../assets/css/login.css'

export default {
  components: {
    LoginForm: LoginForm
  },
  data() {
    var validateName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('账号不能为空'))
      } else {
        callback()
      }
    }
    var validatePa = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('角色不能为空'))
      } else {
        callback()
      }
    }
    var validatePassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('密码不能为空'))
      } else {
        callback()
      }
    }
    return {
      ruleForm: {
        name: '',
        password: '',
        value: ''
      },
      courseLimit: [],
      rules: {
        name: [{ validator: validateName, trigger: 'blur' }],
        password: [{ validator: validatePassword, trigger: 'blur' }],
        value: [{ validator: validatePa, trigger: 'blur' }]
      },
      state: false, //提交状态
      text: '登录' //按钮显示
    }
  },
  mounted() {
    this.$forceUpdate()
  },
  methods: {}
}
</script>

<style lang="less" scoped>
body {
  margin: 0px;
}
.login-body .el-form-item__label {
  color: #fff;
}
*,
*:before,
*:after {
  box-sizing: border-box;
}
.login-body {
  width: 100%;
  min-height: 100%;
  overflow: hidden;
  position: relative;
  background-color: #2d84db;
  padding-left: 1 * 16px;
  padding-right: 1 * 16px;
  height: 100vh;
  box-sizing: border-box;
  // background-color: var(--primary-color);
}
.login-body:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(../../assets/login/login-bg.png);
  background-position: 100%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
/deep/.el-input__inner {
  height: 50px;
  line-height: 50px;
  padding-left: 45px !important;
  border-radius: 10px;
}

/deep/.el-input__prefix {
  line-height: 50px;
  font-size: 24px;
  left: 10px;
}
img {
  vertical-align: middle;
  border-style: none;
}

img,
svg,
iframe {
  display: block;
  vertical-align: middle;
}
img {
  max-width: 100%;
  height: auto;
}
.form-mt {
  margin-top: 13rem;
}
.form-flex {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/login/Login.vue